import { GET_DOCUMENTS, POST_DOCUMENTS, GET_DOCUMENTS_ID, PUT_DOCUMENTS, SIETE_DIAS, DELETE_DOCUMENTS, 
    SALDOS, PUT_ARMADO_ENTREGADO, NO_APROBADOS, PUT_APROBAR_DESAPROBAR, GET_APPROVED, GET_ARMADO, PUT_ARMADO} from "../actions/actionDocument";
import { SIETE_SEND, SIETE_OUT, SIETE_ALL, ALL_DOCUMENTS} from "../../Constantes/constantesFiltros";
import { format } from "date-fns";

const initialState = {
    allDocuments: [],
    allDocumentsClean: [],
    allDocumentsCleanFilter: [],
    documentsDetail: [],
    allNoAprobados: [],
    documentsApproved: [],
    documentsArmado: [],
    postDocuments: {},
    putDocuments: {},
    putArmadoEntregado: {},
    putAprobado: {},
    putArmado: {},
    deleteDocuments: {}
}

export default function reducerDocument(state = initialState, action){
    switch (action.type) {
        case GET_DOCUMENTS:
            return {
                ...state,
                allDocuments: action.payload,
                allDocumentsClean: action.payload,
                allDocumentsCleanFilter: action.payload,
                
            }
        case GET_DOCUMENTS_ID:
            return {
                ...state,
                documentsDetail: action.payload
            }
        case GET_APPROVED:
            return {
                ...state,
                documentsApproved: action.payload
            }
        case GET_ARMADO:
            return {
                ...state,
                documentsArmado: action.payload
            }             
        case POST_DOCUMENTS:
            return {
                ...state,
                postDocuments: action.payload
            } 
        case PUT_DOCUMENTS:
            return {
                ...state,
                putDocuments: action.payload
            }
        case PUT_ARMADO_ENTREGADO:
            return {
                ...state,
                putArmadoEntregado: action.payload
            }
        case PUT_APROBAR_DESAPROBAR:
            console.log(action.payload)
            return {
                ...state,
                putAprobado: action.payload
                }
        case PUT_ARMADO:
            return {
                ...state,
                putArmado: action.payload
            }
        case DELETE_DOCUMENTS:
            return {
                ...state,
                deleteDocuments: action.payload
            }
        // case NO_APROBADOS:
        //     let docNoAprobado = [...state.allDocumentsClean]
        //     console.log(docNoAprobado[0])
        //     let filterNoAprobados = docNoAprobado && docNoAprobado[0].filter(e=> e.approved === false)
        //     return {
        //         ...state,
        //         allDocuments: filterNoAprobados
        //     }
        case SIETE_DIAS:
                const dateHoy = format(new Date(), "yyyy/MM/dd");
                let dateAux = format(new Date(), "yyyy/MM/dd")
                let documents = state.allDocuments
                let documentsAll = [...state.allDocumentsClean]
                console.log(action.payload)
                console.log(documents[1])
                    
                let dateHoyAux = dateHoy.split("/")
                let hoy = new Date(dateHoyAux[0], parseInt(dateHoyAux[1]) - 1, parseInt(dateHoyAux[2]) - 2)
                console.log(hoy)
    
                let date = dateAux.split("/")
                //console.log(date)                
                let aux = new Date(date[0], parseInt(date[1]) - 1, parseInt(date[2]) + 7)
                //console.log(aux)
                let auxDocuments = [];
                //let auxDocumentsTotal = [];
                const inicio = new Date(hoy)
                const fin = new Date(aux);
                const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
                const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
                const formateadorFecha = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', });                                    
                switch(action.payload){
                        case SIETE_SEND:                      
                                    
                            for (let i = inicio; i <= fin; i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)) {
                                let send = format(new Date(i), "yyyy/MM/dd")
                                console.log(send)
                                documentsAll[0].filter( e => {
                                    if(e.dateSend === send){
                                        auxDocuments.push(e)
                                        }                            
                                    })
                                            // console.log(formateadorFecha.format(i));
                            }
                                    console.log(auxDocuments) 
                                return {
                                    ...state,
                                    allDocuments:  [auxDocuments, documents[1], SIETE_SEND] 
                                    } 
                                
                        case SIETE_OUT:
                            // const inicio = new Date(hoy)
                            // const fin = new Date(aux);
                            // const UN_DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24;
                            // const INTERVALO = UN_DIA_EN_MILISEGUNDOS * 7; // Cada semana
                            // const formateadorFecha = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', });                                    
                                    
                            for (let i = inicio; i <= fin; i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)) {
                                let recep = format(new Date(i), "yyyy/MM/dd")
                                console.log(recep)
                                documentsAll[0].filter( e => {
                                    if(e.dateReception === recep){
                                        auxDocuments.push(e)
                                            }                            
                                        })
                                            // console.log(formateadorFecha.format(i));
                        }
                                    //onsole.log(auxDocuments) 
                                        
                                    return {
                                        ...state,
                                        allDocuments:  [auxDocuments, documents[1], SIETE_OUT] 
                                    }
                        case SIETE_ALL:
                            for (let i = inicio; i <= fin; i = new Date(i.getTime() + UN_DIA_EN_MILISEGUNDOS)) {
                                let today = format(new Date(i), "yyyy/MM/dd")
                                console.log(today)
                                documentsAll[0].filter( e => {
                                    if(e.dateSend === today){
                                        auxDocuments.push(e)
                                            }
                                    if(e.dateReception === today){
                                        auxDocuments.push(e)
                                            }                                              
                                        })
                                           // console.log(formateadorFecha.format(i));
                                        }
                                        let auxDocumentsFilter = new Set(auxDocuments)
                                        let auxDocumentsTotal = Array.from(auxDocumentsFilter)   
                                        console.log(auxDocumentsTotal) 
                                        let auxDocumentsTotalSort = auxDocumentsTotal.sort((a, b) => {
                                            if(a.dateSend < b.dateSend){
                                                return -1
                                            } else { return 1}
                                        })
                                                
                                    return {
                                        ...state,
                                        allDocuments:  [auxDocumentsTotalSort, documents[1]] 
                                    }
                        case ALL_DOCUMENTS:
                            return {
                                ...state,
                                allDocuments: documentsAll 
                            }
                        // case SALDADO:
                        //     let allDocuments = state.allDocuments
                        //     let docSaldos = [...state.allDocumentsClean]
                        //     let auxAllDocuments = structuredClone(allDocuments)
                        //     let auxSaldos = []
                        //     console.log(allDocuments)
                        //     console.log(auxAllDocuments)                
                        //     console.log(docSaldos)
                        //     console.log(action)
                        //     console.log(action.payload)

                        //     if(action.payload[0] === SALDADO){
                        //         if(action.payload[1] === true){
                        //             console.log("Verdadero")
                        //             allDocuments[0].filter(e => {
                        //             if(e.state === true){
                        //             auxSaldos.push(e)
                        //             }
                        //         })        
                        //     } 
                        // }


                                default: return{...state}
                        } 
        // case SALDOS:
        //         let allDocuments = state.allDocuments
        //         let docSaldos = [...state.allDocumentsClean]
        //         let auxAllDocuments = structuredClone(allDocuments)
        //         let auxSaldos = []
        //         console.log(allDocuments)
        //         console.log(auxAllDocuments)                
        //         console.log(docSaldos)
        //         console.log(action.payload[0])
        //         console.log(action.payload[1])

        //         if(action.payload[0] === SALDADO){
        //             if(action.payload[1] === true){
        //                 console.log("Verdadero")
        //                 allDocuments[0].filter(e => {
        //                     if(e.state === true){
        //                         auxSaldos.push(e)
        //                     }
        //                 })        
        //             } 
        //             // else {
        //             //   return {
        //             //     ...state,
        //             //     allDocuments: auxAllDocuments
        //             // }
        //             // }                    
        //         } 

        //         return {
        //             ...state,
        //             allDocuments: [auxSaldos, docSaldos[1]]
        //         }


                        // if(action.payload){
                        //     if(action.payload === SALDADO){
                        //         auxFilter = allDocuments[0].filter(e=> e.state === true)
                        //          if(auxFilter){
                        //              return  console.log(auxFilter)
                        //          } else {  auxFilter = allDocumentsAux[0] }

                        //     }
                        //     if(action.payload === NO_SALDADO){
                        //         auxFilter = allDocuments[0].filter(e=> e.state === false)
                        //             if(auxFilter){
                        //                 return console.log(auxFilter)
                        //             } else { auxFilter = allDocumentsAux[0]}
                        //     }
                        // }

                // switch(action.payload){
                //     case SALDADO:
                //             let filterDocSaldos = docSaldos[0].filter(e => e.state === true )
                                                
                //         return {
                //             ...state,
                //             allDocuments: [filterDocSaldos, docSaldos[1]]
                //         }  
                //     case NO_SALDADO:
                //         let filterDocNoSaldos = allDocuments[0].filter(e => e.state === false )
                //         return {
                //             ...state,
                //             allDocuments: [filterDocNoSaldos, docSaldos[1]]
                //             }
                //     case ALL_DOCUMENTS:
                //         return {
                //             ...state,
                //             allDocuments: docSaldos
                //         }
                // }            
            // return {
            //     ...state,
            //     allDocuments: [auxFilter, docSaldos[1]]
            // }
             
        default:
            return {...state};
    }
}